const CREATE_LICENSE = 'LICENSE/CREATE';
const LOAD_LICENSES = 'LICENSE/LOAD';
const LOAD_LICENSES_RESUME = 'LICENSE/LOAD_RESUME';
const SET_LICENSES = 'LICENSE/SET';
const RENEW_LICENSE = 'LICENSE/RENEW';
const EDIT_LICENSE = 'LICENSE/EDIT';
const DELETE_LICENSE = 'LICENSE/DELETE';
const LOAD_EXPIRED_LICENSES = 'LICENSE/LOAD_EXPIRED';

export {
  CREATE_LICENSE,
  EDIT_LICENSE,
  LOAD_LICENSES,
  LOAD_LICENSES_RESUME,
  RENEW_LICENSE,
  SET_LICENSES,
  DELETE_LICENSE,
  LOAD_EXPIRED_LICENSES
};
